export const COMPANY_ADDRESS = {
  ko: '서울 마포구 마포대로 34 (도화동, 도원빌딩), 4층 디플리',
  en: '34, Mapo-daero, Mapo-gu, Seoul, 04174, Rep. of KOREA',
} as const;

export const COMPANY_LOCATION_COORDINATES = {
  lat: 37.539260435206,
  lng: 126.946151540413,
} as const;

export const COMPANY_STRUCTURED_ADDRESS = {
  postalCode: '04174',
  addressCountry: 'KR',
  addressRegion: 'Seoul',
  addressLocality: 'Mapo-gu',
  streetAddress: {
    ko: '서울 마포구 마포대로 34 (도화동, 도원빌딩), 4층 디플리',
    en: '4F, Dowon Building, 34 Mapo-daero',
  },
} as const;
